import {
  __export
} from "./chunk-J5LGTIGS.mjs";

// src/SqlTransaction.ts
var SqlTransaction_exports = {};
__export(SqlTransaction_exports, {
  SqlTransaction: () => SqlTransaction,
  clientLayer: () => clientLayer,
  layer: () => layer
});
import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
import * as SqlClient from "effect/unstable/sql/SqlClient";
var SqlTransaction = class extends Context.Service()("@dxos/sql-sqlite/SqlTransaction") {
};
var layer = Layer.effect(SqlTransaction, Effect.map(SqlClient.SqlClient, (sql) => ({
  withTransaction: (self) => sql.withTransaction(self)
})));
var clientLayer = Layer.effect(SqlClient.SqlClient, Effect.gen(function* () {
  const sql = yield* SqlClient.SqlClient;
  const transaction = yield* SqlTransaction;
  return new Proxy(sql, {
    get: (target, property, receiver) => property === "withTransaction" ? transaction.withTransaction : Reflect.get(target, property, receiver)
  });
}));

export {
  SqlTransaction,
  layer,
  clientLayer,
  SqlTransaction_exports
};
//# sourceMappingURL=chunk-2663B6QO.mjs.map
